import Vue from 'vue'

const Timer = function (durationInSeconds, minTickIntervalSeconds) {
    this.durationInSeconds = durationInSeconds
    if (!Number.isInteger(this.durationInSeconds) || this.durationInSeconds <= 0) {
        throw new Error('Invalid Argument: durationInSeconds must be a positive integer.')
    }

    if (
        (minTickIntervalSeconds || minTickIntervalSeconds === 0) &&
        (!Number.isInteger(minTickIntervalSeconds) || minTickIntervalSeconds <= 0)
    ) {
        throw new Error('Invalid Argument: minTickIntervalSeconds must be a positive integer.')
    }

    this.minTickIntervalMs = (minTickIntervalSeconds || 1) * 1000
    this.EventBus = new Vue()
    this.isStarted = false
    this.timeout = null
    this.startTime = null
}

Timer.prototype = {
    ...Object.prototype,
    isStarted () {
        return this.isStarted
    },
    off (eventId, callback) {
        this.EventBus.$off(eventId, callback)
    },
    on (eventId, callback) {
        this.EventBus.$on(eventId, callback)
    },
    once (eventId, callback) {
        this.EventBus.$once(eventId, callback)
    },
    reset () {
        if (!this.isStarted) {
            throw new Error('Invalid Operation: Timer has not been started.')
        }
        this.stop()
        this.EventBus.$emit('reset')
        this.start()
    },
    start () {
        if (this.isStarted) {
            throw new Error('Invalid Operation: Timer has already been started.')
        }
        this.isStarted = true
        this.startTime = Date.now()
        this._onTick()
    },
    stop () {
        this.isStarted = false
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    },
    _onTick () {
        const now = Date.now()
        const elapsedSeconds = (now - this.startTime) / 1000
        const remainingSeconds = Math.max(0, this.durationInSeconds - elapsedSeconds)

        if (remainingSeconds) {
            this.timeout = setTimeout(this._onTick.bind(this), this.minTickIntervalMs)
            this.EventBus.$emit('tick', elapsedSeconds)
        } else {
            this.stop()
            this.EventBus.$emit('tick', this.durationInSeconds)
            this.EventBus.$emit('end')
        }
    }
}

export default Timer
